import React, { useState, useEffect } from "react";
import { Modal, Button, Typography, Box, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useMutation } from "@apollo/client";
import { UPDATE_INVENTORY_DATA_MUTATION } from "../../graphql/mutation/user";
import CloseIcon from "@mui/icons-material/Close";
import { GET_ALL_INVENTORY } from "../../graphql/queries/user";

const useStyles = makeStyles(() => ({
  paper: {
    position: "absolute",
    width: 500,
    backgroundColor: "white",
    padding: "30px",
    outline: "none",
    borderRadius: "10px",
  },
}));

function getModalStyle() {
  return {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  };
}

function AddCommentsModal(props) {
  const { open, handleClose, handleOpenToaster, selectedRows, queryFilters } =
    props;
  const [comments, setComments] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && selectedRows?.length > 0) {
      setComments(selectedRows[0]?.comments || "");
      setError("");
    }
  }, [open, selectedRows]);

  const [updateInventoryData, { loading }] = useMutation(
    UPDATE_INVENTORY_DATA_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GET_ALL_INVENTORY,
          variables: {
            input: {
              filters: queryFilters,
            },
          },
        },
      ],
    },
  );

  const styles = useStyles();

  const handleChange = (e) => {
    const { value } = e.target;
    setComments(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await updateInventoryData({
        variables: {
          input: {
            ids: selectedRows.map((i) => i.id),
            comments,
          },
        },
      });
      if (response) {
        handleClose();
        setComments("");
        handleOpenToaster("Comments updated successfully!");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={styles.paper} style={getModalStyle()}>
          <Box sx={{ position: "relative" }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Add Comments
            </Typography>

            <CloseIcon
              style={{
                backgroundColor: "rgba(0,0,0,0.12)",
                borderRadius: "20px",
                position: "absolute",
                right: 0,
                top: "5px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </Box>

          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              id="comments"
              label="Comments"
              multiline
              rows={4}
              value={comments}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              placeholder="Enter your comments here..."
              sx={{ mt: 2 }}
            />

            {error && (
              <Box>
                <Typography
                  component="p"
                  variant="p"
                  sx={{ color: "red", mt: 1 }}
                >
                  {error}
                </Typography>
              </Box>
            )}
            <Button
              variant="contained"
              sx={{
                margin: "20px 0",
              }}
              type="submit"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Loading..." : "Submit"}
            </Button>
          </Box>
        </div>
      </Modal>
    </div>
  );
}

export default AddCommentsModal;
